"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisualMediaSource = exports.isVideoSource = exports.isScreenPresenter = exports.isPresenterSource = exports.isMediaSource = exports.isImageSource = exports.isCameraPresenter = exports.isAudioVideoSource = exports.isAudioSource = void 0;
var _Sources = require("@studio/constants/Sources");
var isAudioSource = exports.isAudioSource = function isAudioSource(source) {
  return source && source.type === _Sources.AUDIO_FILE;
};
var isAudioVideoSource = exports.isAudioVideoSource = function isAudioVideoSource(source) {
  return [_Sources.VIDEO_FILE, _Sources.AUDIO_FILE].includes(source.type);
};
var isCameraPresenter = exports.isCameraPresenter = function isCameraPresenter(source) {
  return source && source.type === _Sources.CAMERA_PRESENTER;
};
var isImageSource = exports.isImageSource = function isImageSource(source) {
  return source && source.type === _Sources.IMAGE_FILE;
};
var isMediaSource = exports.isMediaSource = function isMediaSource(source) {
  return [_Sources.VIDEO_FILE, _Sources.AUDIO_FILE, _Sources.IMAGE_FILE, _Sources.PDF_FILE, _Sources.MEDIA].includes(source.type);
};
var isPresenterSource = exports.isPresenterSource = function isPresenterSource(source) {
  return [_Sources.CAMERA_PRESENTER, _Sources.SCREEN_PRESENTER].includes(source.type);
};
var isScreenPresenter = exports.isScreenPresenter = function isScreenPresenter(source) {
  return source && source.type === _Sources.SCREEN_PRESENTER;
};
var isVideoSource = exports.isVideoSource = function isVideoSource(source) {
  return source && source.type === _Sources.VIDEO_FILE;
};
var isVisualMediaSource = exports.isVisualMediaSource = function isVisualMediaSource(source) {
  return [_Sources.VIDEO_FILE, _Sources.IMAGE_FILE, _Sources.SCREEN_PRESENTER, _Sources.PDF_FILE].includes(source.type);
};